export default __webpack_public_path__ + "static/media/myimage.ac281935.jpg";